import React from 'react';

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p>
              The Majestic Hotel & Banquet, located in Lucknow, Uttar Pradesh, is a premier venue known for hosting a variety of events, including weddings, receptions, engagements, corporate events, and social gatherings like birthday parties and conferences. Below is a synthesized "About Us" content based on the available information from various sources:
            </p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h3>Services</h3>
            <ul>
              <li>Wedding </li>
              <li>Engament </li>
              <li>Birthday </li>
              <li>Reception</li>
              <li>Corporate Meeting</li>
            </ul>
          </div>

          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>✉️ Email:  majesticlawnbkt@gmail.com</p>
            <p> 📞 Phone: +91 9935230404</p>
            <p>📍 Address:  Opp. Hanuman Mandir , Near Maa Chandrika Devi Hospital Bakshi Ka Talab Sitapur Road Lucknow - 226201</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Majistic Lawn . All Rights Reserved.</p>
        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <a
        href="https://wa.me/919935230404"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
      </a>





      {/* <div className="icon-bar">
        <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
        <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
        <a href="https://www.google.com" class="google"><i class="fa fa-google"></i></a>
        <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
        <a href="#" class="youtube"><i class="fa fa-youtube-play"></i></a>
      </div> */}




      <a href="tel:+919628873308" className="call-now-btn">
        📞 Call Now
      </a>


    </>
  );
};

export default Footer;
